export type FeedbackSentiment = 'like' | 'dislike';

export interface FeedbackItem {
  id: string; // feedback id
  chatId?: string;
  chatTitle?: string;
  messageId: string;
  sentiment: FeedbackSentiment;
  reasons: string[];
  comment?: string;
  snippet?: string;
  timestamp: string; // ISO string
  context?: {
    prevUserMessage?: string;
  };
}

const QUEUE_KEY = 'CONTROLX_FEEDBACK_QUEUE';

export function enqueueFeedback(item: FeedbackItem) {
  try {
    const raw = localStorage.getItem(QUEUE_KEY);
    const arr: FeedbackItem[] = raw ? JSON.parse(raw) : [];
    arr.push(item);
    localStorage.setItem(QUEUE_KEY, JSON.stringify(arr));
  } catch (e) {
    // Swallow to avoid impacting UX; optionally log
    // console.warn('Failed to queue feedback', e);
  }
}

export function getQueuedFeedback(): FeedbackItem[] {
  try {
    const raw = localStorage.getItem(QUEUE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function clearQueuedFeedback() {
  try {
    localStorage.removeItem(QUEUE_KEY);
  } catch {
    // ignore
  }
}

// Placeholder to integrate with a backend endpoint.
// Call this in the future to POST to your API and then clear the queue.
export async function flushFeedbackQueue(_endpoint?: string) {
  // Intentionally left as a no-op until backend exists.
  return Promise.resolve();
}

